import { render, staticRenderFns } from "./ProductivityTip.vue?vue&type=template&id=22b77cbf&scoped=true"
import script from "./ProductivityTip.vue?vue&type=script&lang=ts"
export * from "./ProductivityTip.vue?vue&type=script&lang=ts"
import style0 from "./ProductivityTip.vue?vue&type=style&index=0&id=22b77cbf&prod&lang=scss&scoped=true"
import style1 from "./ProductivityTip.vue?vue&type=style&index=1&id=22b77cbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b77cbf",
  null
  
)

export default component.exports